import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BottomBar } from "../../components/bar/Bottom.Bar";
import Container from "../../components/layouts/Container";
import { ContextCart } from "../../context/Context.Cart";
import { ContextLanguage } from "../../context/Context.Language";
import {
  TEXT_BUSKET,
  TEXT_NO_BUSKET,
  TEXT_SELECT_SERVICE,
} from "../../utils/useConstants";
import { ICON_EMPTY_BASKET } from "../../utils/useIcons";
import {
  STYLE_ADDRESS_BG,
  STYLE_HEIGHT_BAR,
  STYLE_IMG_EMPTY_BASKET,
  STYLE_MAX_WIDTH_DESKTOP,
  STYLE_PADDING_NO_MB,
  STYLE_SCREEN_FULL,
  STYLE_TEXT_SMS,
} from "../../utils/useStyle";
import ProgramGoBack from "../task/render/Program.GoBack";
import BusketDetails from "./render/Basket.Details";
import OurserviceFirstLoad from "../select/functions/Ourservice.FirstLoad";

const BusketMain = React.memo(({ config, width }) => {
  const location = useLocation();
  const { cart } = React.useContext(ContextCart);
  const { language } = React.useContext(ContextLanguage);
  const navigate = useNavigate();
  const selected = cart?.filter((item) => {
    return item.type === "PACKAGE";
  });

  React.useEffect(() => {
    if (cart?.length === 0) {
      document.getElementById("first-div").scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, [cart]);

  React.useEffect(() => {
    OurserviceFirstLoad();
  }, []);

  if (selected?.length > 0) {
    return (
      <BusketDetails config={config} ContextCart={ContextCart} width={width} />
    );
  } else {
    return (
      <div className={STYLE_SCREEN_FULL} id="scroll_basket">
        <Container>
          <div className={`${STYLE_MAX_WIDTH_DESKTOP} ${STYLE_PADDING_NO_MB}`}>
            <div className={STYLE_ADDRESS_BG}>
              <ProgramGoBack
                title={TEXT_BUSKET[language]}
                onClick={() => {
                  if (location?.pathname === "/Basket") {
                    navigate("/OurServices");
                  } else {
                    navigate(-1);
                  }
                }}
              />
              <ICON_EMPTY_BASKET className={STYLE_IMG_EMPTY_BASKET} />

              <div className={STYLE_TEXT_SMS(language)}>
                {TEXT_NO_BUSKET[language]}
              </div>
            </div>
          </div>
        </Container>
        <BottomBar
          classNameBottomBar={`${STYLE_HEIGHT_BAR}`}
          title={TEXT_SELECT_SERVICE[language]}
          onClick={() => {
            navigate("/OurServices");
          }}
        />
      </div>
    );
  }
});
export default BusketMain;
